import { useSelector } from 'react-redux';
import styles from '../view/FJRecordDevice.module.less';

const FJRecorderFrequencyContainer = () => {
    const recorderFrequency = useSelector(state => state.record.recorderFrequency);
    return (
        <div className={styles.frequency}>
            <div className={styles.frequency_progress} style={{ width: recorderFrequency * 100 + '%' }} />
        </div>
    );
};

export default FJRecorderFrequencyContainer;
